export type CreatorAvatarFrameType = "your-reinvite" | "wishlist" | "aha-picks";

type CreatorAvatarFrameSource = {
  reSendSourceId?: string | null;
  isFromWishlist?: boolean;
  isCoreMatch?: boolean;
};

export const resolveCreatorAvatarFrameType = (
  source?: CreatorAvatarFrameSource | null,
): CreatorAvatarFrameType | null => {
  if (source?.reSendSourceId) {
    return "your-reinvite";
  }
  if (source?.isFromWishlist) {
    return "wishlist";
  }
  if (source?.isCoreMatch) {
    return "aha-picks";
  }
  return null;
};
